import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { RatingBox } from "../ObjectsOnMap/RatingBox";
import PageHeaderNav from "../../components/PageheaderNav";
import "./styles.css";

const NAV_ITEMS = [
  { text: "objects_on_map", permissions: "equipments" },
  { text: "list_objects", permissions: "equipments" },
];

const ObjectsHeader = () => {
  const { t } = useTranslation();

  return (
    <Box className="objects__header">
      <Typography className="title-page">{t("title_page:objects")}</Typography>

      <Box className="objects__header-content" sx={{ gap: "8px" }}>
        <PageHeaderNav itemsNav={NAV_ITEMS} />
        <RatingBox />
      </Box>
    </Box>
  );
};

export default ObjectsHeader;
